var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg333Bf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "333bf 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M164.948 51.5H64.948V151.5H164.948V51.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M165.448 191.5H65.448V291.5H165.448V191.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M165.698 331.5H65.698V431.5H165.698V331.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M406.334 241.663C411.263 165.005 480.269 51.5 347.601 51.5C236.463 51.5 229.005 147.692 229.005 241.663C229.005 326.632 233.049 428.249 335.531 431.826C478.403 436.813 411.812 326.852 406.334 241.663Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Bf);
export default __webpack_public_path__ + "static/media/333bf.713a3eda6c0afbc14a67f5521a82c97f.svg";
export { ForwardRef as ReactComponent };